import { createV3Queries } from "@query/utils/createV3Queries";
import { payPeriodsApi } from "@api";

export const queriesPayPeriods = createV3Queries(
  "payPeriodsApi",
  payPeriodsApi
);
